/*
 * Copyright © 2018, Rezo Zero
 *
 * @file Waveform.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import ASoundObject from './ASoundObject'
import { $window } from '../utils/environment'

export default class Waveform extends ASoundObject {
    constructor (url, type = 'text', active = false) {
        super(url)

        this.type = type
        this.active = active
        this.mask = null
        this.osc = null
        this.amplitude = null
        this.percentage = 0
        this.freq = 0
        this.shift = 0
    }

    setup (p5) {
        super.setup(p5)

        console.log('Waveform - setup')
        this.mask = p5.createGraphics(p5.width, (p5.height) / 2)
        this.mask.pixelDensity(window.devicePixelRatio)
        this.mask.scale(1 / window.devicePixelRatio)

        // Amplitude analyzer for growing circle
        this.amplitude = new window.p5.Amplitude()
        this.amplitude.setInput(this.sound)

        // New oscillator for scroll sound effect
        this.osc = new window.p5.Oscillator()
        this.osc.setType('sine')
        this.osc.freq(this.freq)
        this.osc.amp(0.5)
        this.osc.start()
    }

    draw (p5, blockAutoScroll) {
        if (!this.active) return

        super.draw()

        this.percentage = (this.sound.currentTime() / this.duration) * 100
        this.percentage += this.shift
        this.percentage = p5.min(p5.max(this.percentage, 0), 100)

        p5.clear()

        let pos = this.percentage * p5.height / 100

        this.mask.clear()
        this.mask.noFill()
        this.mask.stroke(255, 100)
        this.mask.strokeWeight(2)
        this.mask.push()
        this.mask.translate(3 * p5.width / 4, -pos * this.waveSpeed)
        this.mask.beginShape()
        this.mask.vertex(0, -1)
        this.mask.vertex(0, 0)

        for (let point of this.points) {
            let offset = point.y - pos * this.waveSpeed
            let coeff = p5.map(offset, 0, -50, 0, 1)
            this.mask.curveVertex(point.x, point.y + p5.height / 2)
            coeff = p5.min(p5.max(coeff, 0), 1)
            point.grow(coeff)
        }

        this.mask.endShape()
        this.mask.pop()

        for (let i = 0; i < this.points[this.points.length - 1].y + p5.height; i += 10) {
            if (i > pos * this.waveSpeed + p5.height / 2) {
                p5.push()
                let x = 3 * p5.width / 4
                let y = i - pos * this.waveSpeed
                p5.translate(x, y)
                p5.ellipse(0, 0, 2, 2)
                p5.pop()
            }
        }

        p5.image(this.mask, 0, 0)
        p5.push()
        p5.translate(3 * p5.width / 4, p5.height / 2)
        p5.fill(255)
        p5.noStroke()

        // Scroll sound effect
        this.osc.freq(this.freq)

        // Draw circle with dynamic amplitude
        let radius = p5.map(this.amplitude.getLevel(), 0, 0.1, 10, 20)
        p5.ellipse(0, 0, radius)

        if (!blockAutoScroll && !this.isJumping) {
            $window.triggerHandler('waveform.scrollTo', {
                percentY: this.percentage,
                pos: pos,
                height: p5.height,
                type: this.type
            })
        }
    }

    onResize (p5) {
        super.onResize(p5)
        this.mask = p5.createGraphics(p5.width, p5.height / 2)
    }

    fadeIn (vol) {
        try {
            if (this.sound && this.volume > 0) {
                this.sound.amp(vol)

                vol += 0.1
                vol = Math.round(vol * 10) / 10

                if (vol < 1) {
                    window.setTimeout(() => {
                        this.fadeIn(vol)
                    }, 100) // 10 steps * 100ms = 1 second fadeIn
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    setAmplitude (amp) {
        this.sound.amp(amp)
    }

    setFrequence (freq) {
        this.freq = freq
    }

    enable () {
        this.active = true
        this.play()
    }

    disable () {
        this.active = false
        this.pause()
        this.osc.freq(0)
    }
}



// WEBPACK FOOTER //
// ./webpack/js/waveform/Waveform.js